<template>
  <z-dialog :show="isVisible" :modalSize="modalSize">
    <template v-slot:header>
      <h4 class="modal-title">
        {{ title }}
      </h4>
      <button type="button" class="btn-close" @click="close"></button>
    </template>
    <template v-slot:body>
      <div class="row">
        <div class="col custom-video">
          <video ref="videoPlayer" :height="videoHeight" controls>
            <source :src="videolink" />
          </video>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-1"></div>
        <div class="col-md-6"></div>
        <div class="col-md-5">
          <div class="custom-buttons">
            <button type="button" class="btn btn-secondary me-2" @click="close">
              Close
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
</template>
<script>
import ZDialog from '@/Components/ZElements/Dialog'
export default {
  name: 'video-dialog',
  components: {
    ZDialog,
  },
  props: {
    show: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalSize: 'modal-xl',
      videoHeight: 480,
      videoWidth: null,
    }
  },
  computed: {
    isVisible() {
      return this.show !== null
    },
    title() {
      let _title = ''
      if (this.show) {
        let paths = this.show.url.split('/').filter((entry) => entry !== '')
        _title = paths[paths.length - 1]
      }
      return _title
    },
    videolink() {
      let _link = ''
      if (this.show) {
        _link = this.show.url
      }
      return _link
    },
  },
  methods: {
    showVideo() {
      this.$refs.videoPlayer.play()
      window.app.$forceUpdate()
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-body {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-buttons {
  position: relative;
  float: right;
}
.custom-video {
  border: 1px solid rgb(189, 189, 189);
  border-radius: 5px;
  padding-right: 15px;
  min-height: 480px;
}
</style>
